import HomePage from "./homepage/HomePage";

const Component = () => {
 return <HomePage />;
};

export default Component;
